import React, { useEffect } from "react";
import "./ProductList.css";
import Product from "./Product";
import AOS from "aos";
import "aos/dist/aos.css";

const Projects = () => {
  useEffect(() => {
    AOS.init({
      offset: 190,
      duration: 600,
      easing: "ease-in-sine",
      delay: 200,
    });
  }, []);
  const products = [
    {
      id: 1,
      img: "https://user-images.githubusercontent.com/80634110/163769837-5a01c892-f0ff-40fd-9068-94d2890d7f4e.png",
      link: "https://github.com/Sahil-pillania/Project_1_AMS",
    },
    {
      id: 2,
      img: "https://user-images.githubusercontent.com/80634110/188208247-7764435d-28ec-4465-8663-15007f258dcc.png",
      link: "https://github.com/Sahil-pillania/gymclub-front-end",
    },
    {
      id: 3,
      img: "https://user-images.githubusercontent.com/80634110/140765717-bc7c8a74-7f50-48fb-8b8c-7e90d6ae9f29.jpg",
      link: "https://github.com/Sahil-pillania/News_World_Laravel_javascript",
    },
    {
      id: 4,
      img: "https://user-images.githubusercontent.com/80634110/188207847-34673915-54a6-4814-a4ae-f2f44f175fad.png",
      link: "https://github.com/Sahil-pillania/Student-Management-_-Laravel-8",
    },
    {
      id: 5,
      img: "https://user-images.githubusercontent.com/80634110/188206893-eda04c0a-7ded-4a33-a039-100411e54bfb.png",
      link: "https://github.com/Sahil-pillania/Foody-frontend",
    },
    {
      id: 6,
      img: "https://user-images.githubusercontent.com/80634110/188207412-0590b420-f0d6-4dd7-b1f2-cc2dfca197b3.png",
      link: "https://github.com/Sahil-pillania/Cars_Game_Vanilla_javascipt",
    },
  ];

  return (
    <div className="pl  PROJECTS">
      <div className="pl-texts">
        <h1 className="pl-title">Create & inspire. It's Sahil </h1>
        <p className="pl-desc">
          There are some of the project shown below developed by me. Hope you
          like them 🥇
        </p>
      </div>
      <div className="pl-list">
        {products.map((item) => (
          <Product img={item.img} key={item.id} link={item.link} />
        ))}
      </div>
    </div>
  );
};

export default Projects;
